"use client";

import { CheckIcon } from "@heroicons/react/24/outline";
import Link from "next/link";
import { useState } from "react";

const Features = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div
      data-testid="homepage-hero"
      className="bg-white from-bgHome via-[#172035] to-bgHome dark:bg-gradient-to-r"
    >
      <div className="relative isolate overflow-hidden">
        <div className="py-32">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto max-w-2xl lg:text-center">
              <h2 className="text-base font-semibold leading-7 text-[#348ddb]">
                Features
              </h2>
              <p className="mt-2 text-pretty text-4xl font-semibold tracking-tight text-[#002243] dark:text-white lg:text-balance">
                Ethically collected data that is clean, standardized and stored
                securely.
              </p>
              <p className="mt-2 text-lg/8 text-[#002243] dark:text-gray-400">
                Ethical data collections are at the core of our mission. We
                provide data for every level with security checks along the way.
              </p>
            </div>
            <div className="mt-10 flex flex-col items-center justify-between gap-10 sm:my-20 lg:flex-row">
              <ul className="ml-10 mt-25 max-w-lg">
                <li className="flex gap-2 py-2 text-gray-600 dark:text-gray-400">
                  <CheckIcon className="mt-0.5 h-5 w-5 flex-none" />
                  Aggregates to post level data
                </li>
                <li className="flex gap-2 py-2 text-gray-600 dark:text-gray-400">
                  <CheckIcon className="mt-0.5 h-5 w-5 flex-none" />
                  Dealing with APIs becomes a thing of the past, Accelerator
                  collects the data for you
                </li>
                <li className="flex gap-2 py-2 text-gray-600 dark:text-gray-400">
                  <CheckIcon className="mt-0.5 h-5 w-5 flex-none" />
                  Data standardized across platforms and media types
                </li>
                <li className="flex gap-2 py-2 text-gray-600 dark:text-gray-400">
                  <CheckIcon className="mt-0.5 h-5 w-5 flex-none" />
                  Standardized incremental data collections and bespoke data
                  collections upon request
                </li>
                <li className="flex gap-2 py-2 text-gray-600 dark:text-gray-400">
                  <CheckIcon className="mt-0.5 h-5 w-5 flex-none" />
                  Secure/Privacy Preserving and IRB-Approved Processing
                  Infrastructure & Compute with Databricks
                </li>
                <li className="flex gap-2 py-2 text-gray-600 dark:text-gray-400">
                  <CheckIcon className="mt-0.5 h-5 w-5 flex-none" />
                  Data anonymization to protect user identities
                </li>
                <li>
                  <div className="ml-7 mt-10 flex gap-x-6">
                    <Link
                      href="/ethics-committee"
                      className="text-md font-semibold leading-6 text-[#002243] dark:text-gray-300"
                    >
                      Learn about our Ethics Committee{" "}
                      <span aria-hidden="true">→</span>
                    </Link>
                  </div>
                </li>
              </ul>
              <img
                src="/images/SidebySide.png"
                alt="Ethics Committee"
                className="h-auto w-full max-w-[320px] object-contain md:max-w-[400px] lg:max-w-[450px]"
              />
            </div>
            <div className="mt-15 flex items-center justify-center gap-x-6">
              <a
                href="/auth/login?screen_hint=signup&returnTo=/auth/verify-email"
                className="text-md cursor-pointer rounded border border-[#002243] bg-[#F4F6FB] p-2 font-semibold leading-6 text-[#002243] hover:bg-[#e9ebf0] dark:border-gray-400 dark:bg-transparent dark:font-medium dark:text-gray-300 hover:dark:bg-white/5 hover:dark:backdrop-blur"
              >
                Start Your Research
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
